/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React, { Component, Suspense } from "react";
//@ts-ignore
//import LazyLoad from 'react-lazyload';

import Loader from './Loader';
const HeroBanners = React.lazy(() => import( "./Hero"));
const SliderNew = React.lazy(() => import( "./Slider_new"));
const AboutBanners = React.lazy(() => import( "./About"));
const TeamBanners = React.lazy(() => import( "./Team"));
const PostBanners = React.lazy(() => import( "./Post"));

const Button1Banners = React.lazy(() => import( "./Button1"));
const Button2Banners = React.lazy(() => import( "./Button2"));




export class App extends Component {
  render() {
    return (
    
      
        <div id="obrien-home">

          <div className="loadering-contain">

          

            <Suspense fallback={<Loader />}>
              
              <section className="HeroBanners">
                <HeroBanners />
              </section>

              <section className="SliderBanners">
                <SliderNew />
              </section>

            </Suspense>

          </div>
          

            <section className="AboutBanners">
              <Suspense fallback={<div>Loader...</div>}>
                <AboutBanners />
              </Suspense>
            </section>

          

            <section className="AboutBelow inside-xl">
              <div className="flex-md justify">
                <div className="forty-five ob-home-catalog">
                  <div className="text-center"><h2>'21 Obrien Catalog</h2></div>
                  <Suspense fallback={<div>Loader...</div>}>
                    <PostBanners />
                  </Suspense>
                  <Suspense fallback={<div>Loader...</div>}>
                    <Button1Banners />
                  </Suspense>
                </div>
                <div className="forty-five ob-home-teams">
                  <div className="text-center"><h2>Featured '21 Team</h2></div>
                  <Suspense fallback={<div>Loader...</div>}>
                    <TeamBanners />
                  </Suspense>
                  <Suspense fallback={<div>Loader...</div>}>
                    <Button2Banners />
                  </Suspense>
                </div>
              </div>
            </section>


            
        </div>

    );
  }
}
export default App;